/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import thunk from 'redux-thunk';
//import DevTools from "./DevTools";
import rootReducer from '../rootReducer';
import { STORE_INITIALIZE } from '../redux/constants/actionTypes';

export function configureStore(initialState) {
  // Middleware and store enhancers
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancers = [applyMiddleware(thunk), autoRehydrate()];

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(...enhancers)
  );
  var storeData = store.getState();
  if (localStorage.getItem('userSelectedLocation')) {
    storeData.dashboard.userSelectedLocation = localStorage.getItem(
      'userSelectedLocation'
    );
  }
  persistStore(
    store,
    {
      blacklist: ['menuCategories', 'rtd'],
      storage: asyncSessionStorage,
    },
    (err, state) => {
      store.dispatch({ type: STORE_INITIALIZE });
    }
  );

  // For hot reloading reducers
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../rootReducer', () => {
      const nextReducer = require('../rootReducer').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }
  return store;
}

export const store = configureStore();



// WEBPACK FOOTER //
// ./src/config/configureStore.js